import { render, staticRenderFns } from "./badage.vue?vue&type=template&id=2d5acfa4&scoped=true&"
import script from "./badage.vue?vue&type=script&lang=js&"
export * from "./badage.vue?vue&type=script&lang=js&"
import style0 from "./badage.vue?vue&type=style&index=0&id=2d5acfa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5acfa4",
  null
  
)

export default component.exports